<script>
import OrderList from '../OrderList'
export default {
  name: 'finished-orders',
  extends: OrderList,
  computed: {
    tabOrder () {
      return this.$store.getters.finishedOrders
    },
    refreshMethod () {
      return 'getFinishedOrders'
    }
  },
  mounted () {
    this.$store.dispatch('getFinishedOrders')
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?6f6ba969